import React from "react";
import FormBaseField from "./FormBaseField";
import TextField from "../field/TextField";

const FormTextField = props => <FormBaseField {...props} fieldComponent={TextField} />;

export default FormTextField;
